import {
  SMS_TEMPLATE_DELETE_FLOW_NAME,
  SMS_TEMPLATE_EDIT_FLOW_NAME,
  SMS_TEMPLATE_INSERT_FLOW_NAME,
  SMS_TEMPLATE_LIST_FLOW_NAME,
} from '@/features/campaigns/v2/Sms/constants';
import { useSmsWorkspace } from '@/features/campaigns/v2/Sms/context/SmsWorkspaceContext';
import { useWorkspace } from '@/features/workspaces/hooks';
import { useGetConnectorFlowsQuery, useGetConnectorInstancesQuery } from '@/services/endpoints/workspace-connectors';

const isSmsFlow = (flow: { name: string; connectorId: string }, name: string, connectorId: string) =>
  flow.name === name && flow.connectorId === connectorId;

export const useSmsTemplateConnector = () => {
  const workspace = useWorkspace();
  const { connectorId } = useSmsWorkspace();

  const {
    data: connectorFlows,
    isLoading: isFlowsLoading,
    isError: isFlowsError,
  } = useGetConnectorFlowsQuery({ workspaceId: workspace.id, queryParams: { showUserJourney: true } }, { skip: !workspace.id });

  const {
    data: connectorInstances,
    isLoading: isInstancesLoading,
    isError: isInstancesError,
  } = useGetConnectorInstancesQuery({ workspaceId: workspace.id }, { skip: !workspace.id });

  const listFlow = connectorFlows?.find((flow) => isSmsFlow(flow, SMS_TEMPLATE_LIST_FLOW_NAME, connectorId));
  const insertFlow = connectorFlows?.find((flow) => isSmsFlow(flow, SMS_TEMPLATE_INSERT_FLOW_NAME, connectorId));
  const editFlow = connectorFlows?.find((flow) => isSmsFlow(flow, SMS_TEMPLATE_EDIT_FLOW_NAME, connectorId));
  const deleteFlow = connectorFlows?.find((flow) => isSmsFlow(flow, SMS_TEMPLATE_DELETE_FLOW_NAME, connectorId));

  const connectorInstanceId = connectorInstances?.find((instance) => instance.connectorId === connectorId)?.id;

  const isLoading = isFlowsLoading || isInstancesLoading;
  const isError = isFlowsError || isInstancesError;

  const isListReady = !!listFlow?.id && !!connectorInstanceId;
  const isInsertReady = !!insertFlow?.id && !!connectorInstanceId;
  const isEditReady = !!editFlow?.id && !!connectorInstanceId;
  const isDeleteReady = !!deleteFlow?.id && !!connectorInstanceId;
  const hasAnySmsFlow = !!listFlow || !!insertFlow || !!editFlow || !!deleteFlow;

  return {
    listFlowId: listFlow?.id,
    insertFlowId: insertFlow?.id,
    editFlowId: editFlow?.id,
    deleteFlowId: deleteFlow?.id,
    listFlow,
    insertFlow,
    editFlow,
    deleteFlow,
    connectorInstanceId,
    connectorId,
    isLoading,
    isError,
    isListReady,
    isInsertReady,
    isEditReady,
    isDeleteReady,
    isReady: isInsertReady,
    missingListFlow: !isLoading && !listFlow,
    missingInsertFlow: !isLoading && !insertFlow,
    missingEditFlow: !isLoading && !editFlow,
    missingDeleteFlow: !isLoading && !deleteFlow,
    missingInstance: !isLoading && hasAnySmsFlow && !connectorInstanceId,
  };
};
